import type { Membership, Capabilities } from 'pkg/api/models/membership';
import { RoleType } from 'pkg/api/models/membership';

export function isPlayer(membership: Membership) {
	if (!membership) {
		return false;
	}

	if (isParent(membership)) {
		return false;
	}

	return membership.role === RoleType.Player;
}

export function isAdmin(membership: Membership) {
	if (!membership) {
		return false;
	}

	return (
		membership.role === RoleType.Admin ||
		membership.role === RoleType.Owner ||
		membership.role === RoleType.ThreeSixtyAdmin
	);
}

export function isStaff(membership: Membership) {
	return membership.role === RoleType.Staff;
}

export function isAdminOrStaff(membership: Membership) {
	if (!membership) {
		return false;
	}

	return isAdmin(membership) || isStaff(membership);
}

export function isParent(membership: Membership) {
	if (membership.targetUserId || membership.isLegalGuardian) {
		return true;
	}

	return false;
}

export function isFamily(membership: Membership) {
	return !!membership?.isFamilyMembership;
}

export function isActive(membership: Membership) {
	return membership.status === 1;
}

export function isPending(membership: Membership) {
	return membership.status === 0;
}

export function valid(membership: Membership) {
	return !!membership.id && !membership.targetUserId && !isParent(membership);
}

export function hasCapability(membership: Membership, flag: Capabilities) {
	return membership.capabilities?.includes(flag) ?? false;
}
